module.exports = __webpack_public_path__ + "img/ic_qytx@3x.6a8cbb9e.png";